export default __webpack_public_path__ + "static/media/mongoDbC.ccfc34f7.webp";